import { useMemo } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { ChangeChip, Popover, PopoverContent, PopoverTrigger } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import {
    FilterWrapper,
    NeutralChip,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/what-changed/WhatChangedWidget.styled";

import { LlmBreakdownTooltip } from "./LlmBreakdownTooltip";
import type { IChangeFilter } from "./types";

export const FilterBadge = ({ type, delta, text, tooltipTitle, onFilter, metricKey, llmBreakdown }: IChangeFilter) => {
    const label = useMemo<string>(() => {
        if (delta === 0) return `0 ${text}`;
        const prefix = type === "positive" ? "+" : "-";
        return `${prefix}${Math.abs(delta)} ${text}`;
    }, [delta, text, type]);

    if (delta === 0) {
        return (
            <NeutralChip alignItems="center">
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[250]}
                >
                    {label}
                </Text>
            </NeutralChip>
        );
    }

    const chip = (
        <FilterWrapper onClick={onFilter}>
            <ChangeChip
                sentiment={type === "positive" ? "positive" : "negative"}
                size="small"
            >
                {label}
            </ChangeChip>
        </FilterWrapper>
    );

    if (!llmBreakdown?.length) {
        return chip;
    }

    return (
        <Popover
            isHover
            placement="top"
        >
            <PopoverTrigger asChild>{chip}</PopoverTrigger>
            <PopoverContent>
                <LlmBreakdownTooltip
                    title={tooltipTitle}
                    metricKey={metricKey}
                    llmBreakdown={llmBreakdown}
                />
            </PopoverContent>
        </Popover>
    );
};
